import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=35df0986&scoped=true"
import script from "./venue.vue?vue&type=script&lang=js"
export * from "./venue.vue?vue&type=script&lang=js"
import style0 from "./venue.vue?vue&type=style&index=0&id=35df0986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df0986",
  null
  
)

export default component.exports